import { useState, useEffect } from 'react';
import React from 'react';
import { getFlagCountAndName, postHrDeny } from '../service/DirectorAPI';
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import $ from 'jquery';
import { connect } from 'react-redux';
import { encryptStorage } from '../constant';

function HRDisagreeFeedback(props) {
    let IndivFlagCounts = {
        green_flag: '',
        red_flag: '',
        yellow_flag: '',
        emp_name: '',
        domain: '',
        profile_img_url: '',
    };

    let FeedbackData = {
        Flags: '',
        Comments: '',
        CommentsBasedOn: '',
    };

    const [feedbackdata, setFeedbackdata] = useState(FeedbackData);
    const [indivFlagCountsData, setIndivFlagCountsData] = useState(IndivFlagCounts);
    const [empId, SetEmpId] = useState(props.empId);
    let FeedbackId = props.FeedbackId; //---------------
    let EvaluationId = props.EvaluationId; //------------
    let login_emp_id = encryptStorage.getItem('employeeId');
    let role = props.role;
    let flag = props.Flag;
    const [hideForm, setHideForm] = useState(true);

    let checkBoxObject = {
        Attitude: false,
        Communication: false,
        Business: false,
        Technology: false,
    };

    let RadioCheck = {
        G: false,
        Y: false,
        R: false,
    };
    let [checkboxCheck, setCheckboxCheck] = useState(checkBoxObject);
    let [radioCheck, setRadioCheck] = useState(RadioCheck);
    let [previousFirstFlag, setPreviousFirstFlag] = useState(props.Flag);
    let [previousSecondFlag, setPreviousSecondFlag] = useState(props.Secondflag);

    useEffect(() => {
        if (props.isHrDenyClicked == true) {
            setHideForm(false);
            // let element = document.getElementById("removeScroll");
            // element.classList.add("removeScroll");
            $('body').addClass('removeScroll');
            loadFlagCountPage();
            setPreviousFirstFlag(props.Flag);
            setPreviousSecondFlag(props.Secondflag);
        }
        //loadGridPage();
    }, [props]);

    const OnChangeName = (e) => {
        setFeedbackdata({ ...feedbackdata, [e.target.name]: e.target.value });
    };

    const handleRadioChecked = (e) => {
        setFeedbackdata({ ...feedbackdata, [e.target.name]: e.target.id });

        if (e.target.id == 'G' && e.target.checked == true) {
            let RadioCheck = {
                G: true,
                Y: false,
                R: false,
            };
            radioCheck = RadioCheck;
            setRadioCheck(radioCheck);
        }
        if (e.target.id == 'Y' && e.target.checked == true) {
            let RadioCheck = {
                G: false,
                Y: true,
                R: false,
            };
            radioCheck = RadioCheck;
            setRadioCheck(radioCheck);
        }
        if (e.target.id == 'R' && e.target.checked == true) {
            let RadioCheck = {
                G: false,
                Y: false,
                R: true,
            };
            radioCheck = RadioCheck;
            setRadioCheck(radioCheck);
        }
    };

    const [isChecked, setIsChecked] = useState([]);

    const handleCheck = (e) => {
        setCheckboxCheck({ ...checkboxCheck, [e.target.id]: e.target.checked });

        let checkboxList = [...isChecked];
        if (e.target.checked) {
            checkboxList = [...isChecked, e.target.id];
        } else {
            checkboxList.splice(isChecked.indexOf(e.target.id), 1);
        }
        setIsChecked(checkboxList);
    };

    const loadFlagCountPage = async () => {
        try {
            let empdata = {
                evaluation_id: EvaluationId,
                emp_id: props.empId, //to_emp_id
                login_emp_id: login_emp_id, //emp_id
            };

            let data = await getFlagCountAndName(empdata);

            if (data.data != undefined && data.data != null && data.data.ResponseData[0].length != 0) {
                let IndivFlagCounts = {
                    green_flag: data.data.ResponseData[0].green_flag,
                    red_flag: data.data.ResponseData[0].red_flag,
                    yellow_flag: data.data.ResponseData[0].yellow_flag,
                    emp_name: data.data.ResponseData[0].emp_name,
                    domain: data.data.ResponseData[0].domain,
                    profile_img_url: data.data.ResponseData[0].profile_img_url,
                };

                setIndivFlagCountsData(IndivFlagCounts);
            }
        } catch (e) {}
    };

    let validationFields = {
        Flags: '',
        Comments: '',
        CommentsBasedOn: '',
    };
    const [message, setmessage] = useState(validationFields);

    const validation = () => {
        if (feedbackdata.Comments == '') {
            message.Comments = 'Drop your comments is required';
            setmessage({ ...message });
        } else {
            message.Comments = '';
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(feedbackdata.Comments);
            if (checkregex) {
                message.Comments = 'Enter a valid comments';
                setmessage({ ...message });
            } else {
                message.Comments = '';
                setmessage({ ...message });
            }
        }

        if (feedbackdata.Flags == '') {
            message.Flags = 'flag is required';
            setmessage({ ...message });
        } else {
            message.Flags = '';
            setmessage({ ...message });
        }
    };

    const cancelClick = () => {
        let valiclearoption = {
            Flags: '',
            Comments: '',
            CommentsBasedOn: '',
        };
        setFeedbackdata(valiclearoption);

        let validationFields = {
            Flags: '',
            Comments: '',
            CommentsBasedOn: '',
        };
        setmessage(validationFields);

        let checkBoxObj = {
            Attitude: false,
            Communication: false,
            Business: false,
            Technology: false,
        };
        checkboxCheck = checkBoxObj;
        setCheckboxCheck(checkboxCheck);

        let ClearRadioCheck = {
            G: false,
            Y: false,
            R: false,
        };
        radioCheck = ClearRadioCheck;
        setRadioCheck(radioCheck);
        setIsChecked('');
        props.setIsHrDenyClick(false);
        setHideForm(true);

        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");
        $('body').removeClass('removeScroll');
    };

    const submitClick = async () => {
        try {
            validation();

            let comments = '';
            for (let i = 0; i < isChecked.length; i++) {
                comments = comments + isChecked[i] + ',';
                if (i == isChecked.length - 1) {
                    comments = comments.slice(0, -1);
                }
            }

            if (comments == '') {
                message.CommentsBasedOn = 'Comments based on is required';
                setmessage({ ...message });
            } else {
                message.CommentsBasedOn = '';
                setmessage({ ...message });
            }

            if (feedbackdata.Flags != '' && feedbackdata.Comments != '' && comments != '' && message.Comments == '') {
                let insertdata = {
                    id: FeedbackId,
                    evaluation_id: EvaluationId,
                    emp_id: empId,
                    login_emp_id: login_emp_id,
                    feedback_by_role: role,
                    reassigned_flags: feedbackdata.Flags,
                    deny_comments_based_on: comments,
                    deny_comments: feedbackdata.Comments,
                    hr_response: 'Disagree',
                    emp_response: 'Pending',
                };

                let responsedata = await postHrDeny(insertdata);
                if (responsedata.data.status == 200) {
                    let notificationids = [];
                    notificationids.push(responsedata.data.ResponseData[0]);

                    let emp = [];
                    notificationids[0].map((obj, index) => {
                        if (obj.emp_id != login_emp_id && !emp.includes(obj.emp_id)) {
                            emp.push(obj.emp_id);
                        }
                    });

                    emp.push(empId);
                    let value = props.empId;

                    await NotificationTrigger(
                        {
                            title: 'Feedback',
                            message: 'Feedback has been denied and updated',
                            route: `/Feedback?EmpId=${value}&FeedbackId=${FeedbackId}&EvaluationId=${EvaluationId}&IsProfile=true&IsTeamMember=true`,
                            state: {},
                            to_employee: emp,
                            by: login_emp_id,
                        },
                        emp,
                        props.websocket
                    );
                    // let valiclearoption = {
                    //     Flags: 0,
                    //     Comments: "",
                    //     CommentsBasedOn: "",
                    // };
                    // setFeedbackdata(valiclearoption);
                    // let checkBoxObj = {
                    //     Attitude: false,
                    //     Communication: false,
                    //     Business: false,
                    //     Technology: false,
                    // }
                    // checkboxCheck = checkBoxObj;
                    // setCheckboxCheck(checkboxCheck);

                    // let ClearRadioCheck = {
                    //     G: false,
                    //     Y: false,
                    //     R: false
                    // }
                    // radioCheck = ClearRadioCheck
                    // setRadioCheck(radioCheck);
                    cancelClick();
                    props.setIsHrDenyClick(false);
                    props.Reload();
                }
            }
        } catch (e) {}
    };

    return (
        <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }}
            hidden={hideForm}
            //id="HrDisagreeFeedbackPopup" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="AddFeedbackDetailsPopupLabel" aria-hidden="true"
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="AddFeedbackDetailsPopupLabel">
                            Reason For Deny
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>
                    <div className="modal-body">
                        <div className="row mb-4">
                            <div className="col-md-12 profile-spacing mb-4">
                                <div className="profile-left d-flex">
                                    <div className="d-flex">
                                        <img
                                            src="/Images/logo-person-user-person-icon.jpg"
                                            alt="User Profile Image"
                                            className="profile-image-feedback"
                                        />
                                    </div>
                                    <div className="d-grid ms-3">
                                        <span className="font-14 semibold-text team-member-name">{indivFlagCountsData.emp_name}</span>
                                        <span className="font-14 pb-0 pt-1 regular-text my-0">{indivFlagCountsData.domain}</span>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className=" d-flex align-items-center me-5">
                                        <div className="profile-feedback-panel profile-feedback-panel-popup profile-feedback-green"></div>
                                        <div className="text-center profile-flag-count mx-2">{indivFlagCountsData.green_flag}</div>
                                    </div>
                                    <div className=" d-flex align-items-center me-5">
                                        <div className="profile-feedback-panel profile-feedback-panel-popup profile-feedback-yellow"></div>
                                        <div className="text-center profile-flag-count mx-2">{indivFlagCountsData.yellow_flag}</div>
                                    </div>
                                    <div className=" d-flex align-items-center">
                                        <div className="profile-feedback-panel profile-feedback-panel-popup profile-feedback-red"></div>
                                        <div className="text-center profile-flag-count mx-2">{indivFlagCountsData.red_flag}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-4">
                                <label className="form-label hive-form-label w-100">
                                    Select Feedback<span className="hive-form-mandatory">*</span>
                                </label>
                                <div className="form-check form-check-inline mt-2">
                                    <input
                                        className="form-check-input hive-form-check-input"
                                        type="radio"
                                        name="Flags"
                                        id="G"
                                        checked={radioCheck.G}
                                        onClick={(e) => handleRadioChecked(e)}
                                        disabled={previousFirstFlag == 'G' || previousSecondFlag == 'G' ? true : false}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="G">
                                        <img
                                            src="/Images/profile-feedback-green.svg"
                                            className="profile-feedback-icon-size"
                                            alt="Green Feedback"
                                        />
                                    </label>
                                </div>
                                <div className="form-check form-check-inline mt-2">
                                    <input
                                        className="form-check-input hive-form-check-input"
                                        type="radio"
                                        name="Flags"
                                        id="Y"
                                        checked={radioCheck.Y}
                                        onClick={(e) => handleRadioChecked(e)}
                                        disabled={previousFirstFlag == 'Y' || previousSecondFlag == 'Y' ? true : false}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="Y">
                                        <img
                                            src="/Images/profile-feedback-yellow.svg"
                                            className="profile-feedback-icon-size"
                                            alt="Yellow Feedback"
                                        />
                                    </label>
                                </div>
                                <div className="form-check form-check-inline mt-2">
                                    <input
                                        className="form-check-input hive-form-check-input"
                                        type="radio"
                                        name="Flags"
                                        id="R"
                                        checked={radioCheck.R}
                                        onClick={(e) => handleRadioChecked(e)}
                                        disabled={previousFirstFlag == 'R' || previousSecondFlag == 'R' ? true : false}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="R">
                                        <img
                                            src="/Images/profile-feedback-red.svg"
                                            className="profile-feedback-icon-size"
                                            alt="Red Feedback"
                                        />
                                    </label>
                                </div>
                                {message.Flags ? (
                                    <label className="hive-form-label w-100 hive-form-mandatory hive-form-mandatory">{message.Flags}</label>
                                ) : null}
                            </div>
                            <div className="col-md-12 mb-4">
                                <label htmlFor="previous-emp-designation" className="form-label hive-form-label w-100">
                                    Comments Based on<span className="hive-form-mandatory">*</span>
                                </label>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input hive-form-check-input"
                                        type="checkbox"
                                        id="Attitude"
                                        checked={checkboxCheck.Attitude}
                                        onClick={(e) => handleCheck(e)}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="Attitude">
                                        Attitude
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input hive-form-check-input"
                                        type="checkbox"
                                        id="Communication"
                                        checked={checkboxCheck.Communication}
                                        onClick={(e) => handleCheck(e)}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="Communication">
                                        Communication
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input hive-form-check-input"
                                        type="checkbox"
                                        id="Business"
                                        checked={checkboxCheck.Business}
                                        onClick={(e) => handleCheck(e)}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="Business">
                                        Business
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input hive-form-check-input"
                                        type="checkbox"
                                        id="Technology"
                                        checked={checkboxCheck.Technology}
                                        onClick={(e) => handleCheck(e)}
                                    />
                                    <label className="form-check-label hive-form-check-label" htmlFor="Technology">
                                        Technology
                                    </label>
                                </div>
                                {message.CommentsBasedOn ? (
                                    <label className=" hive-form-label w-100 hive-form-mandatory">{message.CommentsBasedOn}</label>
                                ) : null}
                            </div>
                            <div className="col-md-12 mb-2">
                                <label htmlFor="Drop-your-comments" className="form-label hive-form-label" >Drop your comments<span className="hive-form-mandatory">*</span></label>
                                <textarea className="form-control hive-form-control" id="Drop-your-comments" placeholder="Drop your comments"
                                    name="Comments" value={feedbackdata.Comments} onChange={(e) => { OnChangeName(e); }} />
                                <label className="hive-form-mandatory">{message.Comments}</label>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn hive-btn-primary"
                            onClick={() => {
                                submitClick();
                            }}
                        >
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}

export default connect(mapStateToProps)(HRDisagreeFeedback);
